import { create } from 'zustand'

export interface Data {
    onCardClick?: () => void
}

interface State {
    data: Data
    setData: (data: Data) => void
}

export const useMenuStore = create<State>(set => ({
    data: {
        onCardClick: undefined,
    },
    setData: (data: Data) => {
        set(prev => {
            return { ...prev, data }
        })
    },
}))
